import axiosIns from '@/plugins/axios'

export default {
  getTimecardStatus() {
    return axiosIns.get('/v2/eod_closing/timecard_statuses')
  },
}
